import { render, staticRenderFns } from "./modalNuevaComision.vue?vue&type=template&id=15ca1fb5&"
import script from "./modalNuevaComision.vue?vue&type=script&lang=js&"
export * from "./modalNuevaComision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports